import type { LucideIcon } from "lucide-react";
import { AlertTriangle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/utils";

export function StediTooltipBadge({
  label,
  tooltip,
  className,
  icon: Icon = AlertTriangle,
}: {
  label: string;
  tooltip: string;
  className?: string;
  icon?: LucideIcon;
}) {
  if (!tooltip.trim()) {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-0.5 rounded-sm px-1.5 py-0.5 text-[10px] font-medium",
          className,
        )}
      >
        <Icon className="h-3 w-3" />
        {label}
      </span>
    );
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              "inline-flex cursor-default items-center gap-0.5 rounded-sm px-1.5 py-0.5 text-[10px] font-medium",
              className,
            )}
          >
            <Icon className="h-3 w-3" />
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-sm whitespace-pre-wrap text-xs leading-relaxed"
        >
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
